export default __webpack_public_path__ + "static/media/restaurant.4a3d8fd6.jpg";